import Papa from 'papaparse';
import type { CsvRow } from '../types';
import { convertGermanNumber } from '../utils/german-number';
import { isCurrencyField } from '../utils/field-utils';

export interface ParsedCsvResult {
  data: CsvRow[];
  errors: Papa.ParseError[];
}

function convertGermanNumbers(row: Record<string, string>): CsvRow {
  const converted: CsvRow = {};
  for (const key in row) {
    if (isCurrencyField(key)) {
      converted[key] = convertGermanNumber(row[key]);
    } else {
      converted[key] = row[key];
    }
  }
  return converted;
}

export function parseCSV(file: File): Promise<ParsedCsvResult> {
  return new Promise((resolve, reject) => {
    Papa.parse<Record<string, string>>(file, {
      header: true,
      delimiter: ';',
      skipEmptyLines: true,
      complete: (results) => {
        if (results.errors.length > 0) {
          console.warn('CSV warnings:', results.errors);
        }

        const convertedData = results.data.map(convertGermanNumbers);

        resolve({
          data: convertedData,
          errors: results.errors
        });
      },
      error: (error) => {
        reject(error);
      }
    });
  });
}
